import React from "react";
import {
  Button,
  Card,
  Container,
  Grid,
  Stack,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import background from "../../../assets/images/contactbg.jpg";

import NearMeIcon from "@mui/icons-material/NearMe";
import AboutImage from "../../../assets/images/about.jpg";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import DraftsIcon from "@mui/icons-material/Drafts";
import emailLogo from "../../../assets/images/email.png";
import { Box } from "@mui/system";
import { Parallax } from "react-parallax";
import { motion } from "framer-motion";

const Contact = () => {
  return (
    <>
      <motion.div
        className="box"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.1, delay: 0.05 }}
      >
        <Parallax
          bgImage={background}
          bgImageAlt="background"
          strength={200}
          width="100%"
        >
          <Grid
            container
            spacing={30}
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{
              // backgroundImage: `url(${background})`,
              padding: 4,
              display: { sm: "flex", xs: "none" },
            }}
          >
            <Grid align="center" item xs={4}>
              <Card sx={{ padding: 2, height: "180px" }}>
                <NearMeIcon color="secondary" fontSize="large" />
                <Typography sx={{ mb: 1 }} variant="h5">
                  Address
                </Typography>
                <Typography variant="subtitle1">
                  1st Floor,Balkrishna Complex, Near Hotel Priyadarshani,Hira
                  Hotel Chowk, Miraj, Maharashtra 416410
                </Typography>
              </Card>
            </Grid>
            <Grid align="center" item xs={4}>
              <Card sx={{ padding: 3, height: "180px" }}>
                <PhoneIcon color="secondary" fontSize="large" />
                <Typography sx={{ mb: 1 }} variant="h5">
                  Phone
                </Typography>
                <Typography variant="subtitle1">+91-7720056190</Typography>
                <Typography variant="subtitle1">+91-9373382921</Typography>
                {/* <Typography variant="subtitle1">+91-7559272207</Typography> */}
              </Card>
            </Grid>
            <Grid align="center" item xs={4}>
              <Card sx={{ padding: 3, height: "180px" }}>
                <EmailIcon color="secondary" fontSize="large" />
                <Typography sx={{ mb: 1 }} variant="h5">
                  Mail
                </Typography>
                <Typography variant="subtitle1">
                  jobtreeplacement@gmail.com
                </Typography>
                {/* <Typography variant="subtitle1">info@jobtree.in</Typography> */}
              </Card>
            </Grid>
          </Grid>
        </Parallax>
      </motion.div>
      <motion.div
        className="box"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.1, delay: 0.05 }}
      >
        <Parallax
          bgImage={background}
          bgImageAlt="background"
          strength={200}
          width="100%"
        >
          <Grid
            container
            spacing={5}
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{
              // backgroundImage: `url(${background})`,
              padding: 4,
              display: { xs: "flex", sm: "none" },
            }}
          >
            <Grid align="center" item xs={12}>
              <Card sx={{ padding: 2, height: "180px" }}>
                <NearMeIcon color="secondary" fontSize="large" />
                <Typography sx={{ mb: 1 }} variant="h5">
                  Address
                </Typography>
                <Typography variant="subtitle1">
                  1st Floor,Balkrishna Complex, Near Hotel Priyadarshani,Hira
                  Hotel Chowk, Miraj, Maharashtra 416410
                </Typography>
              </Card>
            </Grid>
            <Grid align="center" item xs={12}>
              <Card sx={{ padding: 3, height: "180px" }}>
                <PhoneIcon color="secondary" fontSize="large" />
                <Typography sx={{ mb: 1 }} variant="h5">
                  Phone
                </Typography>
                <Typography variant="subtitle1">+91-7720056190</Typography>
                <Typography variant="subtitle1">+91-9373382921</Typography>
                {/* <Typography variant="subtitle1">+91-7559272207</Typography> */}
              </Card>
            </Grid>
            <Grid align="center" item xs={12}>
              <Card sx={{ padding: 3, height: "180px" }}>
                <EmailIcon color="secondary" fontSize="large" />
                <Typography sx={{ mb: 1 }} variant="h5">
                  Mail
                </Typography>
                <Typography variant="subtitle1">
                  jobtreeplacement@gmail.com
                </Typography>
                {/* <Typography variant="subtitle1">info@jobtree.in</Typography> */}
              </Card>
            </Grid>
          </Grid>
        </Parallax>
      </motion.div>
      <motion.div
        className="box"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.1, delay: 0.05 }}
      >
        <Card sx={{ padding: 5 }}>
          <Grid container spacing={3}>
            <Grid item sm={6} xs={12}>
              <img src={emailLogo} alt="email" />
              <Typography variant="h2">Leave Us A Message</Typography>
              <Typography variant="body1">
                For more information or inquiry about our organization please
                feel free to get in touch with us, we will help with any
                questions you may have.
              </Typography>
            </Grid>
            <Grid item sm={6} xs={12}>
              <Stack direction="column" spacing={2}>
                <TextField name="name" label="Your Name" fullWidth />
                <TextField name="email" label="Your Email" fullWidth />
                <TextField name="subject" label="Subject" fullWidth />
                <TextField
                  name="message"
                  label="Message"
                  fullWidth
                  multiline
                  minRows="3"
                  maxRows="10"
                />
                <Button color="primary" variant="contained" size="large">
                  Send Message
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Card>
      </motion.div>
    </>
  );
};

export default Contact;
